/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_ErrorInputs */

const en_inbox_na_error = /** @type {(inputs: Inbox_Na_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not start right now. Try again in a moment.`)
};

const id_inbox_na_error = /** @type {(inputs: Inbox_Na_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum bisa dijalankan sekarang. Coba lagi sebentar.`)
};

/**
* | output |
* | --- |
* | "Could not start right now. Try again in a moment." |
*
* @param {Inbox_Na_ErrorInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_error = /** @type {((inputs?: Inbox_Na_ErrorInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_ErrorInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_error(inputs)
	return en_inbox_na_error(inputs)
});